import { isoToNameMap } from 'constants/currencies'
import { FieldSpec, getEnumValuesFromMap } from 'lib/rich'
import { UnitShorthand } from 'types/unit-shorthand'
import { unit_spec } from './common'
import { MaterialData } from './material'

const currencyEnumValues = getEnumValuesFromMap(isoToNameMap)

export type AssetLink = {
  _uuid: string
  _name: string
}

export namespace EstimatePreset {
  export const Version = 1

  export type Data = {
    unit: UnitShorthand
    currency: string
    baseCost: number
    materialCost: number
    perSetupCost: number
    machiningTimeCost: number
    toolChangeTime: number
    material: AssetLink & MaterialData
  }

  export const Spec: readonly (FieldSpec & { id: keyof Data | undefined })[] = [
    { id: 'unit', ...unit_spec },

    { kind: 'group', title: 'General', id: undefined },

    {
      id: 'machiningTimeCost',
      title: 'Machining Rate',
      kind: 'money_per_hour',
      defaultValue: 60.0,
      required: true,
      gte: 0.0,
    },
    {
      id: 'baseCost',
      title: 'Base Cost',
      kind: 'money',
      defaultValue: 50,
      required: true,
      gte: 0.0,
    },
    {
      id: 'perSetupCost',
      title: 'Cost per Setup',
      kind: 'money',
      defaultValue: 30,
      required: true,
      gte: 0.0,
    },
    {
      id: 'toolChangeTime',
      title: 'Tool Change Time',
      kind: 'duration',
      defaultValue: 3,
      required: true,
      gte: 0.0,
    },

    { kind: 'group', title: 'Material', id: undefined },

    {
      id: 'material',
      title: 'Material',
      kind: 'asset',
      assetType: 'material',
      defaultValue: { _uuid: 'alum6000', _name: '6000 Aluminum' },
      required: true,
      hideChildren: true, // NB: showing children also requires noLabel==false
      noLabel: true,
    },

    {
      id: 'materialCost',
      title: 'Price',
      kind: 'money_per_mass',
      defaultValueMM: 10.0,
      defaultValueIN: 5.0,
      required: true,
      gte: 0.0,
    },

    { kind: 'group', title: 'Localization', id: undefined },

    {
      id: 'currency',
      title: 'Currency',
      kind: 'enum',
      inGroup: true,
      defaultValue: 'USD',
      enumValues: currencyEnumValues,
      required: true,
    },
  ] as const
}
